import type { BadgeTone } from '@shared/ui';

import type { FlagPurpose } from './flag';

/**
 * How a purpose renders.
 *
 * Its own module rather than a constant exported from a page, for the reason
 * `lifecycle.ts` gives: a file that exports both components and values loses
 * Fast Refresh for everything in it, and editing a label would remount the
 * flags table and drop whatever filter the operator had typed.
 */

export const PURPOSE_LABEL: Record<FlagPurpose, string> = {
    release: 'Release',
    operational: 'Operational',
    entitlement: 'Entitlement',
};

/**
 * Deliberately not `brand`, which `flag-type.ts` already spends on `salesforce`:
 * two badges in the same row, same colour, meaning things on different axes is
 * worse than a duller palette.
 */
export const PURPOSE_TONE: Record<FlagPurpose, BadgeTone> = {
    release: 'info',
    operational: 'warning',
    entitlement: 'active',
};

/** Chip order: temporary, then permanent, then sold — the life a flag can have, shortest first. */
export const PURPOSE_ORDER: readonly FlagPurpose[] = ['release', 'operational', 'entitlement'];
